import { AssistantBriefChip } from '@/components/assistant/AssistantBriefChip';
import { AssistantHintChip } from '@/components/assistant/AssistantHintChip';
import { AssistantLauncher } from '@/components/assistant/AssistantLauncher';
import { NotificationBell } from '@/components/common/NotificationBell';

export function PractitionerTopbar() {
  return (
    <header className="hidden lg:flex items-center gap-4 bg-zoowhite border-b border-zooborder px-6 h-16 shrink-0">
      <div className="ml-auto flex items-center gap-2">
        <AssistantBriefChip />
        <AssistantHintChip />
        <AssistantLauncher isCompact={false} />
        <NotificationBell />
      </div>
    </header>
  );
}
